const SET_STUDENTS = (state, students) => {
  state.students = students
}

const ADD_STUDENT = (state, student) => {
  state.students.push(student)
}

const DELETE_STUDENT = (state, id) => {
  state.students = state.students.filter(s => s.id !== id)
}

const EDIT_STUDENT = (state, student) => {
  state.students = state.students.map(s => {
    if (s.id === student.id) {
      return student
    } else {
      return s
    }
  })
}

const IS_LOADED = state => {
  state.isLoaded = true
}

export default {
  ADD_STUDENT,
  DELETE_STUDENT,
  EDIT_STUDENT,
  SET_STUDENTS,
  IS_LOADED
}
